import type { Client } from "graphql-ws";

import { useSyncExternalStore } from "react";

import getSubscriptionClient, { onSubscriptionClientChange } from "~/services/subscriptionClient";

const useSubscriptionClient = (): Client =>
	useSyncExternalStore(onSubscriptionClientChange, getSubscriptionClient, getSubscriptionClient);

export default useSubscriptionClient;
